import ImageAdapter from "theme/components/atoms/Image/ImageAdapter";
import imagesConfig from "config/images";
import fcProxy from "theme/components/atoms/Image/adapters/front-commerce";

const akamaiConfig = {
  paths: ["/"],
  ...(imagesConfig.akamai || {}),
};

class AkamaiAdapter extends ImageAdapter {
  name = "AkamaiAdapter";

  /**
   * @param {string} src
   * @returns {boolean}
   **/
  supportSrc(src) {
    return akamaiConfig.paths.some((path) => {
      return src.startsWith(path);
    });
  }

  /**
   * @type {import("theme/components/atoms/Image/makeImageSrc").makeImageSrc}
   */
  makeImageSrc(
    src,
    format,
    size,
    bg,
    extension,
    cover,
    baseUrl = "",
    focalPoint = undefined
  ) {
    const config = imagesConfig.presets[format];

    if (!size) {
      const sizes = config?.sizes?.length ? config.sizes : [0.5, 1, 2, 4];
      size = sizes[0];
    }

    if (!config) {
      if (process.env.NODE_ENV === "development") {
        console.warn(
          `Image preset for format ${format} could not be found in the configuration. Please check your \`src/config/images.js\``
        );
      }
      return baseUrl + src;
    }

    const colors = config.bgColors || [];

    // We generate and get FC Image Proxy params to handle fallback is Akamai isn't available
    const fcProxyUrl = fcProxy.makeImageSrc(
      src,
      format,
      size,
      bg,
      extension,
      cover,
      baseUrl,
      focalPoint
    );

    // Using Akamai's IMQuery to format the source
    // see https://techdocs.akamai.com/ivm/docs/imquery#syntax-and-examples
    // The format is replaced by an Akamai Property to use original size instead.
    let imageManagerQuery = `&im=`;

    if (focalPoint) {
      imageManagerQuery += `RegionOfInterestCrop=(${config.width * size},${
        config.height * size
      }),regionOfInterest=(${focalPoint.x},${focalPoint.y})`;
    } else if (cover) {
      imageManagerQuery += `FeatureCrop,size=(${config.width * size},${
        config.height * size
      })`;
    } else {
      imageManagerQuery += `Resize=(${config.width * size},${
        config.height * size
      })`;
    }

    if (bg && colors.concat(imagesConfig.defaultBgColor).indexOf(bg) > -1) {
      imageManagerQuery += `;BackgroundColor,color=${bg}`;
    }

    // Using base FC URL with parameters and inject Akamai IMQUERY
    return fcProxyUrl + imageManagerQuery;
  }

  getDefaultExtension() {
    return null; // not used in Akamai, fallback for integrated image proxy
  }

  getSupportedExtensions() {
    return [null]; // not used in Akamai, but we still return a single source
  }
}

export default new AkamaiAdapter();
